import { EProductPlanPaymentInterval } from "@devowl-wp/api-real-commerce";
import { __ } from "../utils/i18n.js";
function localizePaymentInterval(interval) {
    switch(interval){
        case EProductPlanPaymentInterval.OneTime:
            return __("one time");
        case EProductPlanPaymentInterval.Daily:
            return __("day");
        case EProductPlanPaymentInterval.Monthly:
            return __("month");
        case EProductPlanPaymentInterval.Quarterly:
            return __("quarter");
        case EProductPlanPaymentInterval.HalfYearly:
            return __("half year");
        case EProductPlanPaymentInterval.Yearly:
            return __("year");
        default:
            return "";
    }
}
export { localizePaymentInterval };
